<template>
  <v-layout row wrap>
    <v-flex xs12 md8 offset-md2>
      <h1 class="primary--text mb-4">Edit User</h1>
      <app-alert class="mb-3" type="error" :message="error" @dismissed="error = false"/>

      <v-card>
        <v-card-title class="subheading font-weight-bold px-4">
          <span>Update User Account</span>
        </v-card-title>
        <v-divider></v-divider>

        <v-container class="px-4" grid-list-lg>
          <v-form ref="form" @submit.prevent="updateUser" v-if="user">
            <v-layout justify-space-between row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Name"
                  type="text"
                  v-model="user.name"
                  :rules="[rules.isRequired]"
                  @input="canSave = true"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Email"
                  type="text"
                  v-model="user.email"
                  @input="canSave = true"
                  disabled
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-select
                  label="Status"
                  v-model="user.status"
                  :items="statusOptions"
                  @input="canSave = true"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 v-if="user.role && roleOptions.length">
                <v-select
                  label="Role"
                  v-model="user.role"
                  :items="roleOptions"
                  @input="canSave = true"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout class="mt-3">
              <v-btn
                depressed
                color="accent"
                type="submit"
                :disabled="!canSave || isSaving"
              >
                Save
                <v-progress-circular
                  class="ml-3"
                  :indeterminate="true"
                  :size="18"
                  :width="2"
                  v-if="isSaving"
                ></v-progress-circular>
              </v-btn>
              <v-btn flat @click="$emit('disabled')">Cancel</v-btn>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { USER_UPDATE } from '@/store/actions/user'
import { statusOptions, roleOptionsEdit } from '@/data/options'

export default {
	name: 'EditUser',
	props: ['userData'],
	mounted () {
		this.user = Object.assign({}, this.userData)
		delete this.user.created // removes the created timestamp
		delete this.user.modified // removes the modified timestamp
	},
	data () {
		return {
			user: null,
			canSave: false,
			isSaving: false,
			statusOptions: statusOptions,
			error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value)
      }
		}
	},
	computed: {
		roleOptions () {
      return roleOptionsEdit.filter(item => {
        return this.$can(item.can)
      })
    }
	},
	methods: {
    updateUser () {
      if (!this.$refs.form.validate()) return

      this.isSaving = true
      this.$store.dispatch(USER_UPDATE, { 
          isAdmin: this.user.role === undefined, 
          user: this.user
        })
        .then(() => {
          this.$emit('saved')
        })
        .finally(() => {
          this.user = null
          this.error = false
          this.canSave = false
          this.isSaving = false
        })
    }
	}
}
</script>
